@if (form) {
<form [formGroup]="form" (ngSubmit)="onSubmit()" class="controller-shell">
    <div class="layout">
        <aside class="sidebar" aria-label="Seções do controlador">
            <nav>
                @for (section of sections; track section.label; let i = $index) {
                <button
                    type="button"
                    class="nav-btn"
                    [class.active]="selectedTabIndex === i"
                    [attr.aria-current]="selectedTabIndex === i ? 'page' : null"
                    (click)="selectedTabIndex = i"
                >
                    <mat-icon>{{ section.icon }}</mat-icon>
                    <span>{{ section.label }}</span>
                </button>
                }
            </nav>
        </aside>

        <main class="main">
            <div class="main-inner">
                @switch (selectedTabIndex) {
                    @case (0) {
                        @if (entity?.id) {
                        <homeleite-controller-work [controller]="entity"></homeleite-controller-work>
                        }
                    }
                    @case (1) {
                        <app-controller-details-form
                            [form]="form"
                            [entity]="entity"
                            (statusChange)="changeStatus($event)"
                        ></app-controller-details-form>
                    }
                    @case (2) {
                        <app-controller-details-producers
                            [producerSearchCtrl]="producerSearchCtrl"
                            [filteredProducers$]="filteredProducers$"
                            [selectedProducers]="selectedProducers"
                            [minSearchLength]="producerPickerMinLength"
                            (producerSelected)="onProducerSelected($event)"
                            (producerRemoved)="onProducerRemoved($event)"
                        ></app-controller-details-producers>
                    }
                    @case (3) {
                        <app-controller-details-users
                            [entity]="entity"
                            [associatedUsers$]="associatedUsers$"
                            (usersChanged)="loadAssociatedUsers()"
                        ></app-controller-details-users>
                    }
                    @case (4) {
                        @if (entity) {
                        <homeleite-controller-details-logs [controller]="entity"></homeleite-controller-details-logs>
                        }
                    }
                }
            </div>
        </main>
    </div>
    @if (selectedTabIndex === 1) {
    <button mat-fab color="primary" class="floatDefault" type="submit" [disabled]="form.invalid">
        <mat-icon>check</mat-icon>
    </button>
    }
</form>
}
